import React from "react";
import { Link } from "react-scroll";

// Assets
import footerBgLogo from "../../Assets/navLogo.svg";
import whiteCLogo from "../../Assets/whiteSILogo.svg";
import ytube from "../../Assets/whiteYoutube.svg";
import fbook from "../../Assets/whiteFB.svg";
import insta from "../../Assets/whiteInsta.svg";
import linkedIn from "../../Assets/whiteLinkedIn.svg";
import navLogo from "../../Assets/navWhiteLogo.svg";

function container1() {
  return (
    <div className="container1">
      <div className="container1_logo">
        <Link to="homeSection" smooth={true} duration={1000}>
          <img src={whiteCLogo} alt="Stark Industry Logo" />
        </Link>
      </div>
      <div className="container1_content">Stark Industries provides progressive, and affordable 3D ENGINE for everyone</div>
      <div className="container1_social">
        <div className="ytube">
          <img src={ytube} alt="Youtube Channel" />
        </div>
        <div className="fb">
          <img src={fbook} alt="FaceBook Page" />
        </div>
        <div className="insta">
          <img src={insta} alt="Insta Page" />
        </div>
        <div className="linkedIn">
          <img src={linkedIn} alt="LinkedIn Page" />
        </div>
      </div>
    </div>
  );
}

const Container2 = (props) => {
  return (
    <div className="container2">
      <div className="container2_title">
        <div>{props.title}</div>
      </div>
      <div className="container2_content">
        <div className="content1">{props.cOne}</div>
        <div className="content2">{props.cTwo}</div>
        <div className="content3">{props.cThree}</div>
        <div className="content4">{props.cFour}</div>
      </div>
    </div>
  );
};

function Footer() {
  return (
    <div
      className="footer"
      // style={{ background: `url(${footerBgLogo})`, backgroundRepeat: "no-repeat", backgroundPosition: "center" }}
    >
      <div className="footerBody">
        <div className="footerContents">
          {container1()}
          <Container2 title="Company" cOne="About" cTwo="Testimonials" cThree="Find a doctor" cFour="App" />
          <Container2 title="Region" cOne="New York" cTwo="France" cThree="Italy" cFour="Malibu" />
          <Container2 title="Help" cOne="Help center" cTwo="Contact Support" />
        </div>
        <div className="footerLine"></div>
        <div className="underLineContent">
          <div className="underLineContent_text">© 2004-2022, stark industries, Inc. All rights reserved.</div>
          <div className="underLineContent_Logo">
            <Link to="homeSection" smooth={true} duration={1000}>
              <img src={navLogo} alt="Bottom Logo" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
